import React, { memo } from 'react';
import Button from 'src/components/ui/Button/index'
import Text from 'src/components/ui/Text/Text'

import cn from 'classnames';
import * as styles from './PopupPersonalData.module.scss';

import data from "./data";

type PopupPersonalDataProps = {
  type: number;
  onClose?: () => void;
};

const PopupPersonalData: React.FC<PopupPersonalDataProps> = ({ type, onClose }) => {
  const [item] = React.useState(data[type])
  return(
    <div className={styles.popup__container}>
      <div className={styles.popup__title}>
        <Text element="h1" className={styles.popup__title_text}>
          {item.title}
        </Text>
      </div>
      {
        item.content.map((textBlock, index) => (
          <div key={index} className={cn(styles.popup__content, item.content.length - 1 === index && styles.popup__contentWrap)}>
            {
              textBlock.map(text => <Text element="p" className={styles.popup__content_text} align="Left" key={text}>{text}</Text>)
            }
            {
              item.content.length - 1 === index && <div className={styles.popup__buttonWrap}>
                <Button classText={styles.popup__contentButtonText} className={styles.popup__contentButton}  onClick={onClose}>Закрыть</Button>
              </div>
            }
          </div>
        ))
      }
    </div>
  )
}

export default memo(PopupPersonalData);
